import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { doc, onSnapshot, updateDoc } from "firebase/firestore"; // Firestore imports
import { db } from './firebaseconfig.js'; // Firebase config
import BidHistory from './BidHistory';
import BidderForm from './BidderForm';
import CountdownTimer from './CountdownTimer';
import './AuctionItem.css';
import userEvent from '@testing-library/user-event';
import ContactForm from './ContactForm.js';
import closeButton from '../assets/icons/x.svg'
import Logo from '../assets/icons/logo.svg'
import Forward from '../assets/icons/forward.svg'

import {motion, useScroll, useTransform} from "framer-motion";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'




const AuctionItem = () => {

  
  const { id } = useParams();  // Get auction ID from URL
  const location = useLocation();  // Use location to get passed auction data

  const [palette, setPalette] = useState([]);
  const imgRef = useRef(null);

  //const auction = location.state?.auction;  // Access auction from Link state

  const [bids, setBids] = useState([]);
  const [isAuctionActive, setIsAuctionActive] = useState(true);
  const [ended , setHasAuctionEnded] = useState(false);
  const [name, setName] = useState('');  // Track the user's name
  const [timeLeft, setTimeLeft] = useState(null);
  const [isNameSubmitted, setIsNameSubmitted] = useState(false);
  const [tempName, setTempName] = useState('');
  const [auction, setAuction] = useState(null);
  const [start, isStarted] = useState (true)
  const [auctionStartsIn, setAuctionStartsIn] = useState(null);

  const [formSubmit, setFormSubmitted] = useState(false);
  const [thankYou, setThankYou] = useState(false);
  const [isHighestBidder, setIsHighestBidder] = useState(false); // Track if the current user is the highest bidder
  const [email, setEmail] = useState('');  // Track the user's email
  const [showForm, setShowForm] = useState(false); // Form visibility
  const [hasBidError, setHasBidError] = useState(false);


  const ref = useRef(null);
  const {scrollYProgress} = useScroll ({

      target: ref,
      offset: ["start start", ["end start"]],


  });

  const containerStyle = {
    height: hasBidError ?  '80lvh' : !isAuctionActive ? '59lvh' : '73lvh' ,
    transition: hasBidError ? 'height 0.3s ease-in-out' : 'height 0.7s ease-in-out'  ,

  }

  const backgroundY = useTransform(scrollYProgress, [0,1], ["0%", "50%"]);
  


  const localStorageKey = `auction_${id}_bidderName`;


  useEffect(() => {
    if (!id) return; // Ensure auction ID exists


    const auctionRef = doc(db, 'auctions', id);
    const unsubscribe = onSnapshot(auctionRef, (snapshot) => {
      const auctionData = snapshot.data();

      if (snapshot.exists()) {
        setAuction(auctionData);

        setBids(auctionData.bids || []); // Initialize bids from auction data
      }

  
      
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, [id]);

  useEffect(() => {
    const storedFormSubmit = localStorage.getItem(`auction_${id}_formSubmitted`);
    const storedShowForm = localStorage.getItem(`auction_${id}_showForm`);

    // Restore form submission state
    if (storedFormSubmit === 'true') {
      setFormSubmitted(true);
      setShowForm(false);  // Ensure form doesn't reappear
    } else if (storedShowForm === 'true') {
      setShowForm(true); // Only show if highest bidder and form not submitted
    }
  }, [id]);

  useEffect(() => {
    if (auction && auction.bids && auction.bids.length > 0) {
      const highestBid = auction.bids[auction.bids.length - 1];
      const storedBidderName = localStorage.getItem(localStorageKey);

      if (highestBid?.name === storedBidderName && !isAuctionActive) {
        setIsHighestBidder(true);
        if (!formSubmit) {
          setShowForm(true); // Show form only if not already submitted
        }
      } else {
        setIsHighestBidder(false);
        setShowForm(false);  // Hide the form if not the highest bidder
      }
    }
  }, [auction, isAuctionActive, formSubmit]);

  const calculateTimeUntilStart = (startTime) => {
    const now = new Date();
    const timeDiff = startTime - now;
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    
    setAuctionStartsIn({ days, hours, minutes });
  };

  // Auction time management logic
  useEffect(() => {
    if (!auction) return; // Ensure auction data is loaded before accessing its properties
  
    let startTime, endTime;

    if (auction?.startDateTime?.toDate() && auction?.endDateTime?.toDate()) {
      startTime = auction.startDateTime.toDate();
      endTime = auction.endDateTime.toDate();
    }
    
    const updateAuctionStatus = () => {

      const currentTime = new Date();
      if (currentTime < startTime) {
        setHasAuctionEnded(false);
        setIsAuctionActive(false);
      } else if (currentTime >= startTime && currentTime <= endTime) {
        setHasAuctionEnded(false);

        setIsAuctionActive(true);  // Activate auction
        setAuctionStartsIn(null);  // Clear countdown
        setTimeLeft({ start: currentTime, end: endTime });
      } else {
        setIsAuctionActive(false);  // Auction ended
        setHasAuctionEnded(true);
      }
    };

    // Check the auction status every 1 minute
    const intervalId = setInterval(updateAuctionStatus, 1);
    
    // Initial call to set the status without waiting for the interval
    updateAuctionStatus();

    
    return () => clearInterval(intervalId);  // Cleanup the interval on component unmount
  }, [auction, isAuctionActive]);

  useEffect(() => {
    const storedName = localStorage.getItem(localStorageKey);
    if (storedName) {
      setName(storedName);
      setIsNameSubmitted(true);  // Set name as submitted
    }

    if (!isAuctionActive) {
      setIsNameSubmitted(true);
    }

    
  }, [setIsNameSubmitted]);

  

  

  

  const handleNewBid = async (newBid) => {
    const bidWithTimestamp = {
      ...newBid,
      timestamp: Date.now(), // Add a timestamp to each new bid
    };
  
    const updatedBids = [...bids, bidWithTimestamp];
    setBids(updatedBids); // Update local state
  
    // Update bids in Firebase
    try {
      const auctionRef = doc(db, 'auctions', id); // Get the auction document reference
      await updateDoc(auctionRef, {
        bids: updatedBids, // Update the bids field in Firestore
      });

    } catch (error) {
      console.error('Error saving bid to Firebase:', error);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const auctionRef = doc(db, 'auctions', id);
      await updateDoc(auctionRef, {
        winnerContact: { name, email }  // Save winner's name and email
      });
      setFormSubmitted(true);
      setThankYou(true);
      setShowForm(false);  // Hide form after submission
      localStorage.setItem(`auction_${id}_formSubmitted`, 'true');  // Persist submission state
    } catch (error) {
      console.error('Error saving contact information:', error);
    }
  };
  

  
  const handleAuctionEnd = () => {
    setIsAuctionActive(false);
    setHasAuctionEnded(true);
  };

  const closeForm = () => {
    setThankYou(false);
    setShowForm(false);
    localStorage.setItem(`auction_${id}_formSubmitted`, 'true');  // Persist submission state
  };


    

  const handleNameSubmit = (e) => {
    e.preventDefault();
    if (tempName) {
      setName(tempName);
      setIsNameSubmitted(true);

      // Save the name to localStorage
      localStorage.setItem(localStorageKey, tempName);
    }
  };

  const subscribeToAuction = (auctionId) => {
    const auctionRef = doc(db, 'auctions', auctionId);
    return onSnapshot(auctionRef, (snapshot) => {
      if (snapshot.exists()) {
        setAuction(snapshot.data()); // Update auction data in real time
      }
    });
  };



  
  

  
  

  if (!auction) {
    return <div style = {{padding: "2%", marginLeft: "3%", marginTop: "8vh"}}>
             <Skeleton width="90vw" height= "87vh"  baseColor='light-dark( var(--skeleton-light), var(--skeleton-dark))' highlightColor = "light-dark( var(--skeleton-highlight-light), var(--skeleton-highlight-dark))" enableAnimation = {true} duration={0.5} borderRadius={30}/>
               </div>
  }

  return (
    <div className = "a-container" ref= {ref}> 

      <header>

        <img src = {Logo} className= 'logo'></img>

      </header>

      
 
      <>
 
      {!isNameSubmitted && (
        <div className="name-container">
          <div className="name-input">
            <form onSubmit={handleNameSubmit}>
              <input
                type="text"
                placeholder="Enter your name"
                value={tempName}
                onChange={(e) => setTempName(e.target.value)}
                required
                className="name-input"
                maxLength={10}
              />
                          <button type="submit" className="submit-button"><img src = {Forward} className = 'name-forward-button'></img></button>

            </form>
          </div>
        </div>
      )}

      </>

  
      {isNameSubmitted && (

      <div className={`background-content ${showForm ? 'blurred' : ''}`}>


        <div className="auction-container"  >
          <div className = "image-container" style = {{y: backgroundY}}>
            <motion.div className= "image-display" >
              {auction?.imageUrl ? (
                  <img
                    src={auction?.imageUrl}
                    alt={auction?.name || "Auction item"}

                  
                  />
                ) : (
                  <p>No image available for this auction.</p>
                )}
          
                </motion.div>
              </div>
          <div className="bid-history-container">
            <div className = "description-mask" style = {containerStyle}>
              <div className = "item-info" >
              <div className ="name-wrapper">

                <h1>{auction?.name}</h1>
                {/* <div className = "fade-wrapper-description">

                    <div className = "item-description">
                      <h2>{auction?.description}</h2>
                      </div>
                  </div> */}
              </div>

            <div className = "bid-info-container">
            
            {new Date() < new Date(auction?.startDateTime.toLocaleString()) ? auctionStartsIn && (

        <p>The auction hasn't started yet. It will begin in {auctionStartsIn.days} days, {auctionStartsIn.hours}, hours and {auctionStartsIn.minutes}minutes </p>
      ) : (
        <>
          <div className = "bid-floor-height">


              <div className = "start-increment-wrapper">

                  <p className="starting-bid">Starting Bid: ${auction?.startingBid}</p>

               </div>
        

               <span><h3 className="highest-bid"><strong>Highest Bid: ${bids[bids.length - 1]?.amount}</strong></h3></span>
               
          </div>

                  <CountdownTimer auctionStartTime = {auction?.startDateTime.toDate()}auctionEndTime={ auction?.endDateTime.toDate()} onAuctionEnd={handleAuctionEnd} />
                  

                  <BidHistory bids={bids} />
                  </>
                  
      )}
                    </div>




          
          

            <>
            
            <div className="bidder-name-form">
              <BidderForm
                onNewBid={handleNewBid}
                highestBid={bids[bids.length - 1]?.amount || auction?.startingBid}
                isAuctionActive={isAuctionActive}
                name={name}
                bidIncrement={auction?.bidIncrement}
                setShowError = {setHasBidError}
              />
            </div>


          </>
            

            </div>

       
          </div>


          </div>
        </div>

        </div>

        
      )}
      

      <div className = "form-filter">

      {!isAuctionActive && isHighestBidder && (

      <div>
      

        {showForm && !formSubmit &&(

          <div className = {`winner-form-wrapper ${showForm ? 'form-visible' : ''}`}>
              <h1>Congratulations, you were the highest bidder!</h1>
              <p>Enter your name and email address so we can proceed with payment and shipping information. </p>

              <p>You will recieve an email from <strong>contact.dominicbloomfield@gmail.com</strong> within 24 hours.</p>

              <div className="winner-form" >
                <form onSubmit={handleFormSubmit} >
                  <label>
                    <input
                      type="text"
                      value={name}
                      placeholder='Enter your name'
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </label>
                  <div className = "input-button-wrapper">
                  <label >
                    <input
                      type="email"
                      value={email}
                      placeholder='Enter your e-mail'
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </label>
                  <button type="submit" >Submit</button>
                  </div>
                </form>

                </div>
                </div>

                
                )}

                {thankYou &&(
                  <div className = "thank-you-container">
                   {/* <button className = "closeButton" onClick={closeForm}><img src = {closeButton} className = 'closeImg' ></img></button>  */}
                   <button className = "closeButton" onClick={closeForm}>
                    <div className = "cBtn-container">
                      <span className='close1'></span>
                      <span className='close2'></span>
                    </div>
                    
                    </button> 
                  <h1>Thanks for collecting!</h1>
                  <h3>Your contact information has been submitted.</h3>
                 </div>
                  
                )}
            </div>

      )}


    </div>

    </div>

    
  );
};

export default AuctionItem;
